<template>
    <section class="custom-dashboard">
        <div class="container stack">
            <MobileMenu v-if="this.$store.getters.isMobile" />
            <h1 class="page-title text-center text-base"><strong class="text-large-heading">Step 2</strong> <br><span class="text-large-sub-heading">Which subcategories would you like to learn about?</span></h1>

            <div class="swipe-group">

                <div @click="removeFromDashboard" class="swipe-nav swipe-nav--left" :class="{'is-active': willRemove}">
                    <button>
                        <svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg>
                        <span>No Thanks</span>
                    </button>
                </div>

                <div class="stacks">
                    <span class="stacks-icon stacks-icon--left"><svg class="icon icon-Left"><use xlink:href="#icon-Left"></use></svg></span>

                    <vue-swing
                        ref="vueswing"
                        @throwout="throwout"
                        @dragmove="drag"
                        @dragend="enddrag"
                        :config="swingConfig"
                        class="card-stack">

                        <template v-for="(driver, index) in selectedDrivers">
                            <div class="card-flip-container" v-for="(subDriver, subIndex) in driver.children" :key="subDriver.name">
                                <div class="card-flip">
                                    <div class="card card--front" :class="driver.color">
                                        <span><svg class="icon" :class="'icon-'+driver.abbreviation+'-simple'"><use v-bind="{'xlink:href':'#icon-'+driver.abbreviation+'-simple'}"></use></svg></span>
                                        <h3>{{driver.name}}</h3>
                                        <p class="text-callout">{{subDriver.name}}</p>
                                        <div class="button-group">
                                            <button class="button is-ghost" @click="flipCard"><svg class="icon icon-Info"><use xlink:href="#icon-Info"></use></svg>More Info</button>
                                            <a class="button is-white heart" href="#" @click="like"><svg class="icon icon-Heart"><use xlink:href="#icon-Heart"></use></svg>Super Like</a>
                                        </div>
                                    </div>
                                    <div class="card card--back" :class="driver.color">

                                        <p class="h3">
                                            {{subDriver.description}}
                                        </p>

                                        <div class="button-group">
                                            <button class="button is-ghost" @click="flipCard"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg>Back</button>
                                            <a class="button is-white heart" href="#" @click="like"><svg class="icon icon-Heart"><use xlink:href="#icon-Heart"></use></svg>Super Like</a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </template>
                    </vue-swing>

                    <span class="stacks-icon stacks-icon--right"><svg class="icon icon-Right"><use xlink:href="#icon-Right"></use></svg></span>
                </div>

                <div @click="addToDashboard" class="swipe-nav swipe-nav--right" :class="{'is-active': willAdd}">
                    <button>
                        <svg class="icon icon-Check"><use xlink:href="#icon-Check"></use></svg>
                        <span>Add to Dashboard</span>
                    </button>
                </div>

            </div>

            <div class="mobile-swipe-navs">
                <div class='wrapper'>
                    <div class="swipe-nav swipe-nav--left" :class="{'is-active': willRemove}">
                        <button @click="removeFromDashboard">
                            <svg class="icon icon-Left"><use xlink:href="#icon-Left"></use></svg>
                            <span>Remove</span>
                        </button>
                    </div>
                    <div class="swipe-nav swipe-nav--right" :class="{'is-active': willAdd}">
                        <button @click="addToDashboard">
                            <svg class="icon icon-Right"><use xlink:href="#icon-Right"></use></svg>
                            <span>Add</span>
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';
    import VueSwing from '../components/VueSwing';
    import MobileMenu from './../components/MobileMenu';

    export default {
        data : function() {
            return {
                swingConfig: {
                    throwOutConfidence: function(xOffset, yOffset, element){
                        var xConfidence = Math.min(Math.abs(xOffset) / ( element.offsetWidth / 3 ), 1);
                        var yConfidence = Math.min(Math.abs(yOffset) / ( element.offsetHeight / 3 ), 1);

                        return Math.max(xConfidence, yConfidence);
                    },
                    allowedDirections: [VueSwing.Direction.LEFT, VueSwing.Direction.RIGHT]
                },
                step: 1,
                cardStacks: {},
                activeStack: false,
                cardCount: 0,
                willAdd: false,
                willRemove: false,
                addLike: false
            }
        },
        watch: {
            step: function () {

                //determine if we've passed the last stack and if so,
                //redirect to the next step
                if ( this.step > Object.keys(this.cardStacks).length ) {
                    let self = this;

                    setTimeout( function(){
                        // reset this back to 0 so if you go back to step-2 it will reswipe all drivers
                        self.$store.commit('setReSwipeDriver', 0);
                        router.push({ name: "rankDrivers"});
                    }, 1000);
                    return;
                }

                //reset the category
                let category = false;
                let index = this.selectedDrivers.length - this.step;
                let drivers = this.selectedDrivers;

                //update the category to the active steps category
                category = drivers[index].abbreviation;

                //update the stacks and dispatch the necessary events
                //to update the global data store
                this.cardStacks[category].active = true;
                this.activeStack = this.getActiveStack();
                this.cardCount = this.activeStack.cardCount;

                this.$store.dispatch('changeCategory', category);
                EventBus.$emit('nav.updateStacks', this.cardStacks);
            },
            cardCount: function (val) {
                //if cardCount hits zero, move on to the next step
                if ( val <= 0 ) {
                    this.activeStack.complete = true;
                    this.activeStack.active = false;
                    this.cardStacks[this.activeStack.category] = this.activeStack;
                    this.step = this.step + 1;
                }
            }
        },
        created() {
            //if there aren't any drivers in the data store,
            //redirect back to step 1
            if ( this.selectedDrivers.length == 0) {
                router.push({ name: "selectDrivers"});
            }

            //update the stacks whenever the addStack event is fired
            EventBus.$on( 'addStack', (cards) => {
                this.updateStack(cards);
            });

            EventBus.$on( 'updateDrivers', (data) => {
                this.$store.dispatch('updateDrivers', this.drivers);
            });

        },
        computed: {
            selectedDrivers() {
                //add global drivers that are selected to the components
                //local data. Reversed for display purposes

                let drivers = this.$store.getters.drivers,
                    singleDriverId = this.$store.getters.driverToReSwipe,
                    swipeDriverPos = -1;

                drivers  = drivers.filter(function(driver) {
                    return driver.selected;
                });

                // check for single swipe, if so override drivers being swiped
                if ( singleDriverId > 0 && drivers.length > 1 ) {
                    drivers  = drivers.filter(function(driver) {
                        if ( driver.id === singleDriverId ) {
                            return driver.selected;
                        }
                    });
                }

                for (var i = 0; i < drivers.length; i++) {
                    drivers[i].children.reverse();
                }

                return drivers.sort( window.compareValues('order') ).reverse();
            },
            drivers() {
                return this.$store.getters.drivers;
            },
            stacks() {
                //create stacks from the global drivers
                //stacks refer to the various sets of "cards".
                //Each main driver is a stack, with each sub driver
                //being an individual card
                let stacks = {};

                for (var i = this.selectedDrivers.length - 1; i >= 0; i--) {

                    let newStack = {
                        id: this.selectedDrivers[i].id,
                        name: this.selectedDrivers[i].name,
                        category: this.selectedDrivers[i].abbreviation,
                        cardCount: this.selectedDrivers[i].children.length,
                        active: false,
                        complete: false,
                        children: this.selectedDrivers[i].children,
                    }

                    if ( this.selectedDrivers[i].abbreviation == this.$store.getters.category ) {
                        newStack.active = true;
                    }

                    stacks[ this.selectedDrivers[i].abbreviation ] = newStack;
                }

                return stacks;
            }
        },
        mounted() {
            //reset all likes and selected sub drivers
            for (var i = 0; i < this.drivers.length; i++) {
                this.drivers[i].likes = 0;
                for (var j = 0; j < this.drivers[i].children.length; j++) {
                    this.drivers[i].children[j].liked = false;
                    this.drivers[i].children[j].selected = false;
                }
            }
            //update the category and stacks
            this.$store.dispatch('changeCategory', this.selectedDrivers[this.selectedDrivers.length - 1].abbreviation);
            this.cardStacks = this.stacks;
            this.activeStack = this.getActiveStack();
            this.cardCount = this.activeStack.cardCount;

            EventBus.$emit('nav.updateAction', 'steps');
            EventBus.$emit('nav.updateStacks', this.cardStacks);

            $('.card-flip-container:nth-last-child(2)').addClass('can-animate');
        },
        methods : {
            getActiveStack() {
                let activeStack = false;

                for( let category in this.cardStacks ) {
                    if ( this.cardStacks[category].active ) {
                        activeStack = this.cardStacks[category];
                    }
                }

                return activeStack;
            },
            flipCard(event) {
                $(event.target).closest('.card-flip').toggleClass('active');
            },
            throwout(e) {

                //fired by Swing.js when a card has been removed from the deck.
                let card = this.$refs.vueswing.stack.getCard( e.target );
                this.updateSelectedDrivers(e);

                this.cardCount = this.cardCount - 1;

                setTimeout( function(){
                    e.target.style.transition = 'opacity 0.3s linear';
                    e.target.style.opacity = 0;

                    setTimeout( function() {
                        e.target.remove();

                        setTimeout( function(){
                            $('.card-flip-container.can-animate').removeClass('can-animate');
                            $('.card-flip-container:nth-last-child(2)').addClass('can-animate');
                        }, 500);
                    }, 300);
                }, 500);

            },
            drag(e) {
                //fired by Swing.js when a card is being dragged / moved. Determine its direction
                //and show visual affordance to match the appropriate action
                if ( e.throwDirection == VueSwing.Direction.RIGHT && e.throwOutConfidence == 1 ) {
                    this.willAdd = true;
                    this.willRemove = false;

                } else if ( e.throwDirection == VueSwing.Direction.LEFT && e.throwOutConfidence == 1 ) {
                    this.willRemove = true;
                    this.willAdd = false;

                } else {
                    this.willAdd = false;
                    this.willRemove = false;
                }
            },
            enddrag(e) {
                //fired by Swing.js when a card is done being dragged / moved.
                //Reset all visual affordance
                this.willAdd = false;
                this.willRemove = false;
            },
            updateSelectedDrivers(e) {
                if ( e.throwDirection == VueSwing.Direction.RIGHT ) {
                    this.addDriver();
                } else if ( e.throwDirection == VueSwing.Direction.LEFT ) {
                    this.removeDriver();
                }
            },
            removeDriver() {
                let subDriverObject = this.activeStack.children[this.cardCount - 1];
                subDriverObject.selected = false;


                for (var i = 0; i < this.activeStack.children.length; i++) {
                    if ( this.activeStack.children[i].id === subDriverObject.id ) {
                        this.activeStack.children[i].selected = false;
                    }
                }
                this.$store.dispatch('updateDrivers', this.drivers);
            },
            addDriver() {
                let subDriverObject = this.activeStack.children[this.cardCount - 1];

                let parentDriver = this.drivers.filter(function(driver){
                    return driver.id === subDriverObject.parent_id;
                });

                subDriverObject.selected = true;
                parentDriver[0].selected_drivers = parentDriver[0].selected_drivers + 1;

                if ( this.addLike ) {
                    subDriverObject.liked = true;
                    parentDriver[0].likes = parentDriver[0].likes + 1;
                    this.addLike = false;
                }

                for (var i = 0; i < this.activeStack.children.length; i++) {
                    if ( this.activeStack.children[i].id === subDriverObject.id ) {
                        this.activeStack.children[i].selected = true;
                    }
                }
                this.$store.dispatch('updateDrivers', this.drivers);
            },
            addToDashboard() {
                let cardEl = $('.card-flip-container:last-child').get(0);
                let card = this.$refs.vueswing.stack.getCard( cardEl );
                let plusOrMinus = Math.random() < 0.5 ? -1 : 1;
                cardEl.style.transition = 'transform 0.25s cubic-bezier(.17,.67,.7,1.45), opacity 0.3s 0.25s linear';
                card.throwOut(100,  Math.floor( (Math.random() * (50 * plusOrMinus ) ) + plusOrMinus ) );
            },
            removeFromDashboard() {
                let cardEl = $('.card-flip-container:last-of-type').get(0);
                let card = this.$refs.vueswing.stack.getCard( cardEl );
                let plusOrMinus = Math.random() < 0.5 ? -1 : 1;
                cardEl.style.transition = 'transform 0.25s cubic-bezier(.17,.67,.7,1.45), opacity 0.3s 0.25s linear';
                card.throwOut(-100,  Math.floor( (Math.random() * (50 * plusOrMinus ) ) + plusOrMinus ) );
            },
            updateStack(cards) {

            },
            like(event) {
                let cardEl = event.target.closest('.card-flip-container');
                let card = this.$refs.vueswing.stack.getCard( cardEl );
                let plusOrMinus = Math.random() < 0.5 ? -1 : 1;
                this.addLike = true;
                //animate the heart
                event.target.classList.add('is-animated');

                cardEl.style.transition = 'transform 0.25s cubic-bezier(.17,.67,.7,1.45), opacity 0.3s 0.25s linear';
                //throw the card out, but give it some room to breath
                //750ms to be exact
                setTimeout( function(){
                    card.throwOut(100,  Math.floor( (Math.random() * (50 * plusOrMinus ) ) + plusOrMinus ) );
                }, 750);
            },
            compareStep(index) {
                let stepIndex = index + 1;
                return this.step == stepIndex;
            }
        },
        components: {
            VueSwing,
            MobileMenu
        },
    }
</script>

<style lang="css" scoped>
    .custom-dashboard {
        overflow-y: auto;
        min-height: 100vh;
    }

    .swipe-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .swipe-group > div {
        flex: 1 1 auto;
    }

    .mobile-swipe-navs {
        display: none;
    }

    @media screen and (max-width: 1440px) {
        .stacks {
            max-width: 800px;
        }

        .stacks-icon--left {
            padding-left: 1em;
        }

        .stacks-icon--right {
            padding-right: 1em;
        }

        .card-stack {
            min-width: 400px;
            height: 60vh;
        }

        .swipe-nav {
            max-width: 100px;
        }
    }

    @media screen and (max-width: 992px) {
        .container.stack {
            padding-left: 0;
            padding-right: 0;
        }

        .stacks-icon--left {
            padding-left: 0;
            top: 54%;
            left: 0.5em;
        }

        .stacks-icon--left .icon {
            width: 0.75em;
            height: 0.75em;
        }

        .stacks-icon--right {
            padding-right: 0;
            top: 54%;
            right: 0.5em;
        }

        .stacks-icon--right .icon {
            width: 0.75em;
            height: 0.75em;
        }

        .swipe-nav {
            max-width: 80px;
        }

        .swipe-nav .icon {
            width: 0.5em;
            height: 0.5em;
        }

        .card-stack {
            min-width: 360px;
        }
    }

    @media screen and (max-width: 660px) {
        .stacks-icon--left, .stacks-icon--right {
            display: none;
        }

        .swipe-group .swipe-nav {
            display: none;
        }

        .mobile-swipe-navs {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2em;
            margin-bottom: 6em;
        }

        .mobile-swipe-navs .wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 360px;
        }

        .mobile-swipe-navs .swipe-nav .icon {
            width: 0.35em;
            height: 0.35em;
        }

        .mobile-swipe-navs .swipe-nav span {
            margin-top: 1em;
        }

        .card-stack {
            height: 55vh;
        }

        .mobile-swipe-navs {
            margin-top: 5em;
            margin-bottom: 7em;
        }
    }

    @media screen and (max-width: 400px) {
        .card-stack {
            min-width: 85%;
            height: auto;
        }

        .card-stack .card {
            padding: 1.5em;
        }

        .card-stack .button-group {
            /* padding: relative !important;
            left: initial;
            right: initial;
            bottom: initial; */
            /* margin-top: 2em; */
            left: 1.5em;
        }

        .card-stack .text-callout {
            font-size: 2em;
        }

        .button-group {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: calc(100% - 2em);
        }

        .button-group .button.is-white {
            margin-left: 0.5em;
            margin-top: 1em;
        }

        .page-title {
            margin-top: 5em;
        }

        .mobile-swipe-navs {
            width: 90%;
            margin-left: 5%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/StepTwo.vue